<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Pages</h1>
    <div class="mb-6 flex justify-between items-center">
        <nav-button-link :href="route('admin.pages.create')">
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;new page</span>
        </nav-button-link>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Title</th>
                <th class="px-6 pt-6 pb-4">Slug</th>
                <th class="px-6 pt-6 pb-4">Status</th>
                <th class="px-6 pt-6 pb-4">Actions</th>
            </tr>
            <tr v-for="page in pages.data" :key="page.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <inertia-link :href="route('admin.pages.edit', page.id)" class="px-6 py-4 flex items-center text-indigo-500">
                        {{ page.title }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <inertia-link :href="route('admin.pages.edit', page.id)" class="px-6 py-4 flex items-center">
                        {{ page.slug }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge class="mr-2" :type="page.status ? 'green' : 'gray'">
                            {{ page.status ? 'Active' : 'Hidden' }}
                        </badge>
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <nav-button-link class="mr-2" type="red" :href="route('admin.pages.edit', page.id)">
                            <span>Edit Page</span>
                        </nav-button-link>
                        <nav-button-link type="indigo" :href="route('page.show', page.slug)">
                            <span>Visit Page</span>
                        </nav-button-link>
                    </span>
                </td>
            </tr>
            <tr v-if="pages.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No pages found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="pages.links" />
</app-layout>
